import { render, staticRenderFns } from "./width.vue?vue&type=template&id=6487f300"
import script from "./width.vue?vue&type=script&lang=js"
export * from "./width.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports